// GO4S Design System — plomberie ARIA commune aux widgets « disclosure »
// (menu, export, select, multiselect…) : reflète l'état ouvert/fermé sur le
// déclencheur. Source unique — toute évolution (ex. refléter aussi l'état sur
// l'élément de contrôle) se fait ici, pas dans chaque contrôleur.
export function setTriggerExpanded(controller, expanded) {
  if (controller.hasTriggerTarget) {
    controller.triggerTarget.setAttribute("aria-expanded", String(expanded));
  }
}
